module.exports = __webpack_public_path__ + "img/logo2.cb75176e.png";